const jobDomains = [
    'Software Development',
    'Web Development',
    'Mobile App Development',
    'Front-end Development',
    'Back-end Development',
    'Full Stack Development',
    'DevOps',
    'Database Administration',
    'Cloud Computing',
    'Network Administration',
    'Cybersecurity',
    'UI/UX Design',
    'Data Science',
    'Machine Learning',
    'Artificial Intelligence',
    'Natural Language Processing',
    'Blockchain Development',
    'Virtual Reality Development',
    'Augmented Reality Development',
    'Game Development',
    'IT Support',
    'Network Security',
    'System Administration',
    'IT Project Management',
    'Quality Assurance',
    'Business Analysis',
    'Technical Writing',
    'IT Consulting',
    'Embedded Systems Development',
    'Mobile Game Development',
    'E-commerce Development',
    'IT Sales',
    'IT Training and Education',
    'Software Testing',
    'IT Architecture',
    'Big Data Analytics',
    'Digital Marketing',
    'Content Management',
    'ERP Implementation',
    'IT Governance',
    'Health Informatics',
    'Telecommunications Engineering',
    'Wireless Communication',
    'Network Design',
    'IT Recruitment',
    'IT Procurement',
    'Data Engineering',
    'Data Warehousing',
    'Cloud Architecture',
    'UI/UX Research',
    'AR/VR Design',
    'IT Risk Management',
    'IT Compliance',
    'Robotics Process Automation',
    'Geographic Information Systems (GIS)',
    'ITIL Implementation',
    'IT Security Analysis',
    'Linux System Administration',
    'Containerization',
    'Microservices Architecture',
    'Front-end Frameworks (e.g., React, Angular, Vue.js)',
    'Back-end Frameworks (e.g., Node.js, Django, Ruby on Rails)',
    'Programming Languages (e.g., Python, Java, JavaScript)',
    'Cyber Threat Intelligence',
    'Penetration Testing',
    'Cryptocurrency Development',
    'Quantum Computing',
    'Biometrics',
    'Space Exploration',
    'Mining Engineering'
    // Add more job domains as needed
  ];
  export default jobDomains